import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NoData from '@components/NoData';
import { toastError } from '@components/Toast';

import SampleRequest from '@features/sampleDevelopment/components/SampleRequest';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { isPageReachBottom } from '@utils/Util';

const RequestedSampleFromCollection = ({ id }) => {
	const [allRequests, setAllRequests] = useState(null);
	const [page, setPage] = useState(0);
	const isLoading = useSelector((store) => store.loaderStore);

	const scrollRef = useRef({});
	const dispatch = useDispatch();

	const setCurrentState = (data) => {
		scrollRef.current = data;
	};

	const getSampleRequestForAccountManagers = async () => {
		dispatch(openLoader());
		await ApiClient.GET(
			'getSampleRequestForAccountManagers',
			`${id}?page=${page}&size=${20}&sort=id,desc`
		)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					setAllRequests(data);
					setCurrentState(data);
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};
	useEffect(() => {
		getSampleRequestForAccountManagers();
	}, [page]);

	useEffect(() => {
		document.addEventListener('scroll', handleScroll);
		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleScroll = () => {
		if (isPageReachBottom()) {
			let { totalElements, data } = scrollRef.current;
			if (totalElements > 0) {
				if (totalElements !== data.length) {
					setPage((page) => page + 1);
				}
			}
		}
	};

	return (
		<div className="sample-dashboard-container on-sample-tab bg-gray">
			{allRequests?.data?.length === 0 && !isLoading ? (
				<NoData message={'No sample request found'} />
			) : (
				allRequests?.data?.map((item) => (
					<div className="mt-3 sample-items-row" key={item.id}>
						<SampleRequest dataItem={item} />
					</div>
				))
			)}
		</div>
	);
};

export default RequestedSampleFromCollection;
